import lozad from 'lozad';

// Initialize the Lozad observer
const observer = lozad('.lazy-load', {
    rootMargin: '0px 0px',
    threshold: 0.2,
    enableAutoReload: true,
    loaded: function(el) {
        el.classList.add('loaded');
    }
});

export const initializeLozad = () => {
    observer.observe();
};

initializeLozad();